/**
 * ExecutionSummary — summary section container of the execution detail page.
 *
 * Redux-connected: selects the mapped ExecutionDetailView from the
 * executionDetail slice and composes the pure leaves (status line, headline
 * identifiers + executionDetails document, tags). Renders nothing until an
 * execution is loaded.
 */
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useAppSelector } from 'src/store/hooks';
import { CorrelationTags } from '../../paymentDetails/summary/CorrelationTags';
import { ExecutionStatusLine } from './ExecutionStatusLine';
import { ExecutionDetailsView } from './ExecutionDetailsView';

export const ExecutionSummary = () => {
  const detail = useAppSelector(state => state.executionDetail.data);
  if (!detail) return null;

  return (
    <Container>
      <SpaceBetween size="m">
        <ExecutionStatusLine
          id={detail.id}
          statusLabel={detail.statusLabel}
          statusType={detail.statusType}
          locationBadge={detail.locationBadge}
        />
        <ExecutionDetailsView detail={detail} />
        <CorrelationTags tags={detail.correlationTags} />
      </SpaceBetween>
    </Container>
  );
};
